import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Button, EmptyState, GridCell } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
export function ErrorState(props) {
    const { onRefetch } = props;
    return (<GridCell style={{ gridColumn: 'span 12', gridRow: 'span 3' }}>
      <EmptyState withAvatar icon={<Falcon icon="exclamation"/>} title={t({
            message: 'Error',
            comment: 'Contact library list - Error state - title',
        })} description={t({
            message: 'Something went wrong while loading the contacts',
            comment: 'Contact library list - Error state - description',
        })} actions={<Button type="button" onClick={onRefetch} appearance="secondary" size="small">
            <Trans comment="Contact library list - Error state - Try again button label">Try again</Trans>
          </Button>}/>
    </GridCell>);
}
